import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
//import { Observable, throwError, BehaviorSubject } from 'rxjs';
//import { catchError, retry } from 'rxjs/operators';
import { APIResponse, LatLon, MapGeoCoordinate, TravelEstimate } from '../models/models';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    })
};

@Injectable()
export class AzureMapsService {
    constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {
    }

    public getMileage(originCityId: number, destinationCityId: number) {
        var employeeId = localStorage.getItem('EmployeeId')!;
        return this.http.get<number>(this.baseUrl + 'api/AzureMaps/GetMiles/?originCityId=' + originCityId + '&destinationCityId=' + destinationCityId + '&employeeId=' + employeeId);
    }

    public getTravelEstimate(originCityId: number, destinationCityId: number, trailerTypeID: number) {
        var employeeId = localStorage.getItem('EmployeeId')!;
        return this.http.get<TravelEstimate>(this.baseUrl + 'api/AzureMaps/GetTravelEstimate/?originCityId=' + originCityId + '&destinationCityId=' + destinationCityId + '&trailerTypeID=' + trailerTypeID + '&employeeId=' + employeeId);
    }

    public getTravelEstimateFromPickupStopByCityIdLineId(cityID: number, quoteOrderLineID: number) {
        return this.http.get<TravelEstimate>(this.baseUrl + 'api/AzureMaps/GetMilesFromPickupStopByCityIdLineId/?cityId=' + cityID + '&lineId=' + quoteOrderLineID);
    }

    public getTruckRouteFromCityIds(lineId: number, cityIds: number[]) {
        var params = new HttpParams().set('ids', cityIds.join(','));
        params = params.append("lineid", lineId.toString());

        return this.http.get<MapGeoCoordinate[]>(this.baseUrl + 'api/AzureMaps/GetTruckRouteFromCityIds/', { params });
    }

    public getTruckRouteFromCityIDList(cityIds: number[]) {
        var params = new HttpParams().set('cityIDList', cityIds.join(','));
        return this.http.get<LatLon[]>(this.baseUrl + 'api/AzureMaps/getTruckRouteFromCityIDList/', { params });
    }

    public getGeoCoordinateByAddress(country: string, state: string, zip: string, city: string, address: string) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/AzureMaps/GetGeoCoordinateByAddress/?country=' + country + '&state=' + state + '&zip=' + zip + '&city=' + city + '&address=' + address);
    }

    public getGeoCoordinateByFullAddress(address: string) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/AzureMaps/getGeoCoordinateByFullAddress/?address=' + address);
    }

    public getGeoCoordinateByStructuredAddress(streetNumber: string, streetName: string, cityName: string, stateName: string, postalCode: string, countryCode: string) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/AzureMaps/getGeoCoordinateByStructuredAddress/?streetNumber=' + streetNumber + '&streetName=' + streetName + '&cityName=' + cityName + '&stateName=' + stateName + '&postalCode=' + postalCode + '&countryCode=' + countryCode);
    }

    public getGeoCoordinateByLatLon(latitude: number, longitude: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/AzureMaps/GetGeoCoordinateByLatLon/?latitude=' + latitude + '&longitude=' + longitude);
    }

    public getCityByLatLon(latitude: number, longitude: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/AzureMaps/getCityByLatLon/?latitude=' + latitude + '&longitude=' + longitude);
    }

    public getTimeZoneByLatLon(latitude: number, longitude: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/AzureMaps/getTimeZoneByLatLon/?latitude=' + latitude + '&longitude=' + longitude);
    }
}
